// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '../css/public.scss'

import TrackEvents from './shared/tracks'
import Notifications from './modules/notifications'

function fixHeader() {
  const body = document.getElementById('body')
  const scrollBarPosition = window.scrollY || document.documentElement.scrollTop

  if (!body) return

  body.classList.toggle('fixed', scrollBarPosition > 300)
}

window.addEventListener('DOMContentLoaded', () => {
  const body = document.getElementById('body')
  if (body) {
    document.addEventListener('scroll', fixHeader, { passive: true })
  }
})

window.togglePassword = function () {
  const icon = document.getElementById('passwordToggle')
  const field = document.getElementById('user_password')

  if (icon && field) {
    icon.classList.toggle('open')
    field.type = field.type === 'password' ? 'text' : 'password'
  }
}

new TrackEvents()
new Notifications()
